import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { AnimatedPageLoader } from 'smartsuite-ui';

export default function ViewController(props) {
    const [currentStateOfViews, setCurrentStateOfViews] = useState({});
    const [activeViewKey, setActiveViewKey] = useState();

    useEffect(() => {
        setCurrentStateOfViews(props.views);
        const viewKeys = Object.keys(props.views);
        if (viewKeys.length) {
            setActiveViewKey(
                props.viewKey ? props.viewKey : props.views[viewKeys[0]].viewKey
            );
        }
    }, [props.viewKey, props.views]);

    function changeView(viewKey, view) {
        setCurrentStateOfViews((prevState) => ({
            ...prevState,
            [activeViewKey]: { ...view, lastViewedTimestamp: Date.now() },
        }));
        setActiveViewKey(viewKey);
        window.history.pushState(null, null, viewKey);
    }

    if (_.isEmpty(currentStateOfViews) || !activeViewKey) {
        return <AnimatedPageLoader />;
    }

    return props.render({
        activeView: currentStateOfViews[activeViewKey],
        changeView,
        viewOptions: _.map(currentStateOfViews, ({ viewKey, viewLabel }) => ({
            viewKey,
            viewLabel,
        })),
    });
}

ViewController.propTypes = {
    render: PropTypes.func.isRequired,
    viewKey: PropTypes.string,
    views: PropTypes.instanceOf(Object),
};

ViewController.defaultProps = {
    viewKey: undefined,
    views: {},
};
